export { default as FloorPlansNameHero } from './floor-plans-name-hero';
